module.exports = __webpack_public_path__ + "static/media/OH.61a07817.wav";